import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  style: {"width":"33rem","max-width":"80vw"},
  class: "relative edit-body h-full"
}
const _hoisted_2 = { class: "gap-x-3 px-6 pb-6 pt-4 flex justify-center flex-col gap-y-4" }
const _hoisted_3 = { class: "mt-2 w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_InputVehicleNo = _resolveComponent("InputVehicleNo")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_Select = _resolveComponent("Select")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      class: "dialog-airport",
      modelValue: _ctx.show,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.show = $event)),
      title: _ctx.$t('cargoV2.components.common.completeBookingData'),
      persistent: "",
      customBody: "py-3",
      onReset: _ctx.onReset
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('cargoV2.components.common.vehicleSerialNumber')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SelectSearch, {
                  "is-loading": _ctx.loadingDriver,
                  options: _ctx.driverOptions,
                  onFocus: _ctx.fetchDrivers,
                  onFilter: _cache[1] || (_cache[1] = e => _ctx.fetchDriversDebounced(e, _ctx.$t)),
                  modelValue: _ctx.driver,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => (_ctx.driver = $event)),
                    _ctx.onSelectDriver
                  ],
                  placeholder: _ctx.$t('cargoV2.components.common.searchVehicleSerialNumber'),
                  serverSide: false,
                  class: "mt-1.5",
                  keyName: "label",
                  keyValue: "value"
                }, null, 8, ["is-loading", "options", "onFocus", "modelValue", "onUpdate:modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            (_ctx.driver.value === 'other')
              ? (_openBlock(), _createBlock(_component_InputVehicleNo, {
                  key: 0,
                  modelValue: _ctx.form.cargoVehicleNo,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.cargoVehicleNo = $event)),
                  "is-valid": _ctx.isValidCargoVehicleNo,
                  "onUpdate:is-valid": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isValidCargoVehicleNo = $event))
                }, null, 8, ["modelValue", "is-valid"]))
              : _createCommentVNode("", true),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('cargoV2.components.common.commodity')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CustomDropdown, {
                  class: "w-full mt-1.5",
                  placeholder: _ctx.$t('cargoV2.components.common.selectCommodity'),
                  options: _ctx.commodityOptions,
                  onSelect: _ctx.onSelectCommodity,
                  selectedItem: _ctx.form.cargoCommodity,
                  isCustomWidth: "",
                  isDisabled: _ctx.disableCommodityGroup
                }, null, 8, ["placeholder", "options", "onSelect", "selectedItem", "isDisabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('cargoV2.components.common.product'),
              class: "w-full"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Select, {
                  onOpenSelect: _ctx.onOpenSelectCargoProduct,
                  onCloseSelect: _ctx.onCloseSelectCargoProduct,
                  isOpenMenu: _ctx.isOpenSelectCargoProduct,
                  value: _ctx.form.productCargo,
                  onChooseSelect: _ctx.onSelectCargoProduct,
                  dataSelect: _ctx.listProductCargo,
                  customClass: "w-full",
                  class: "w-full whitespace-no-wrap mt-1.5 z-10"
                }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('cargoV2.components.common.cargoNumber'),
              tooltipDescription: _ctx.$t('cargoV2.components.common.cargoNumber')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  modelValue: _ctx.form.cargoNo,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.cargoNo = $event)),
                  placeholder: _ctx.$t('cargoV2.components.modalBookingShip.inputCargo')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label", "tooltipDescription"]),
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_LpButton, {
                textColor: "white",
                title: _ctx.$t('cargoV2.components.common.booking'),
                fontWeight: "semibold",
                color: "red-lp-100",
                isWidthFull: "",
                customClass: "py-2 px-8",
                onClick: _ctx.onConfirmBooking,
                disabled: _ctx.disabled
              }, null, 8, ["title", "onClick", "disabled"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title", "onReset"]),
    _createVNode(_component_Loading, { "model-value": _ctx.bookingLoading }, null, 8, ["model-value"])
  ], 64))
}